import { Component } from "@angular/core";
import { NgForm } from "@angular/forms";
 
@Component({
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"]
})
export class HomeComponent {
  contentClass: any = 'not-submitted'
  model: any = {};
  memberSelectList = [{ 'id': undefined, 'name': undefined }, { 'id': 1, 'name': 'ABC' }, { 'id': 2, 'name': 'XYZ' }];
  membershipTypeId: any;
  approvedDate = '12/12/2008';
  value: string;
  defaultPicUrl: string = 'images/BaghaLogo.jpg'
  array = ['images/slider1.jpg', 'images/slider2.jpg', 'images/slider3.jpg', 'images/slider4.jpg'];

  formValidate: boolean = true;
  //selectedItem: any = {};
  constructor() {
    this.model.surname = undefined;
    this.model.membershipTypeId = undefined;
    this.model.approvedDate = undefined;
  }
  register(myForm: NgForm) {
    console.log('Successful registration');
    console.log(myForm);
  }
  onSubmit(myForm: NgForm) {
    this.contentClass = 'submitted'
    console.log('onSubmit', myForm.valid);
    //this.messageService.showSuccess('saved');

  }
}
